// System Interface Constants
import SDLUtil from '@/utils/SDLUtil';
import _ from 'lodash';

let sysLogNameList;
export let sysUrlList;

export const initSysUrlList = () => {
  sysUrlList = [ // 타 시스템의 도메인 리스트 (domain list of other systems)
    {
      systemName: 'ipaGlobal', // 시스템명 (토큰 생성 생성시 사용)
      systemLogName: getSysLogName('IPA'), // 시스템명 (로그 생성시 사용)
      url: `${SDLUtil.getExternalUrl('IPA')}${SDLUtil.getExternalUrl('IPA_AUTH_ENDPOINT')}`,
      isUseScopToken: true, // SCOP토큰 연계 여부
      isConnectionLog: true, // 접속로그 생성 여부
      isUseAccessType: true, // 접속방법 구분 여부
    },
    {
      systemName: 'ipaChina',
      systemLogName: 'IPA-CN',
      url: `${SDLUtil.getExternalUrl('IPA_CN')}`,
      isUseScopToken: true,
      isConnectionLog: true,
      isUseAccessType: true,
    },
    {
      systemName: 'itVoc',
      systemLogName: getSysLogName('IT-VOC'),
      url: `${SDLUtil.getExternalUrl('ITVOC')}`,
      isUseScopToken: false,
      isConnectionLog: true,
      isUseAccessType: false,
    },
    {
      systemName: 'scmp',
      systemLogName: getSysLogName('SCMP'),
      url: `${SDLUtil.getExternalUrl('CLOUD_IN_ONE')}`,
      isUseScopToken: false,
      isConnectionLog: true,
      isUseAccessType: false,
    },
    {
      systemName: 'nirp',
      systemLogName: getSysLogName('NIRP'),
      url: `${SDLUtil.getExternalUrl('NIRP')}`,
      isUseScopToken: false,
      isConnectionLog: true,
      isUseAccessType: false,
    },
  ];
}

// 공통코드 內 시스템명 조회
const getSysLogName = (labelParam) => {
  if (_.isEmpty(sysLogNameList)) sysLogNameList = SDLUtil.getCommCodeList({ commCodeTypeId: 'CONNECTION_SYS_LINK' });

  const system = _.find(sysLogNameList, { label: labelParam });
  return _.isEmpty(system) ? labelParam : system.code;
}

export let accessType = { // 접속방법 구분
  ACTION: 'Action', // 사용자 행동으로 접속 (버튼클릭 등)
  REDIRECTION: 'Redirection', // SCOP 리다이렉션으로 접속
  TEST: 'Test',
}

export default {
  sysUrlList,
  accessType,
  initSysUrlList,
}



// WEBPACK FOOTER //
// ./src/constants/SysLinkConstants.js